import { FormControl, FormHelperText, FormLabel, TextField } from '@mui/material';
import { Component } from 'react';

export default class Username extends Component {
    render() {
        return (
            <TextField
                {...this.props.props}
                sx={this.props.sx}
                error={this.props.error === true}
                helperText={this.props.error === true ? "Informe nome de usuário válido" : null}
                size="small"
                variant="outlined"
                name="username"
                label={'Usuário' + (this.props.required ? '*': '')}
                value={this.props.value}
                onChange={e => this.props.onChange ? this.props.onChange(e.target.value) : {}} />
        );
    }
}